function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#portfolio-logo_svg__clip0_4052_16202)",
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.804 24.322l-1.127-3.365h.496l1.035 3.105h-.25l1.073-3.105h.443l1.05 3.105h-.241l1.05-3.105h.456l-1.126 3.364h-.505l-.982-2.879h.13l-.987 2.88h-.515zm6.577-1.913h1.732v.408h-1.732v-.408zm.043 1.494h1.964v.419h-2.445v-3.365h2.377v.418h-1.896v2.528zm3.798.419l1.525-3.365h.477l1.53 3.364h-.505l-1.362-3.095h.192l-1.362 3.096h-.495zm.65-.842l.13-.384h1.896l.14.384H15.87zm4.95.841v-3.364h.48v2.946h1.825v.419h-2.305zm4.776 0v-2.946h-1.155v-.418h2.787v.418h-1.155v2.947h-.477zm6.137-3.364h.481v3.364h-.481v-3.364zM29.8 24.321h-.482v-3.364h.482v3.364zm1.978-1.5h-2.026v-.417h2.026v.418z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.806.85v17.704h3.618v-3.001h.922c1.426 0 2.88-.065 4.21-.58C36.737 11.804 33.42.851 26.49.851h-6.684zm3.618 11.333V4.16h3.066c3.246 0 5.021 5.999.758 7.772-.488.203-1.026.252-1.555.252h-2.27z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.495.865H2.959v10.24c0 10.436 15.323 10.497 15.323 0V.865h-3.66v10.24c0 4.01-3.269 4.215-3.943 4.214a2.43 2.43 0 01-.241-.012c-.673-.066-3.943-.574-3.943-4.202V.865z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "portfolio-logo_svg__clip0_4052_16202"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(-.01 .85)",
  d: "M0 0h36.262v24.673H0z"
})));

function SvgPortfolioLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 26,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgPortfolioLogo;